<script>
  import RecursiveSection from '@/views/app/dashboard/footer-pages/components/RecursiveSection.vue';

  export default {
    name: 'SectionRenderer',
    components: { RecursiveSection },
    props: {
      sections: {
        type: Array,
        required: true,
      },
      activeSectionIndex: {
        type: Number,
        required: false,
      },
    },
  };
</script>

<template>
  <ol>
    <li
      v-bind="section.title ? { id: section.title.toLowerCase().replace(/ /g, '-') } : {}"
      class="section"
      :class="section.type"
      v-for="(section, i_section) in sections"
      :key="section.title + i_section"
    >
      <h2 v-if="section.title" v-html="section.title" />
      <v-expansion-panels v-if="section.type === 'spoilers'" class="mt-3 mb-15" :value="activeSectionIndex">
        <v-expansion-panel
          class="section"
          v-for="(section_child, i) in section.children"
          :key="i"
          @click="$emit('click', section_child)"
          :id="section_child.title.toLowerCase().replace(/ /g, '-')"
        >
          <v-expansion-panel-header>
            {{ section_child.title }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <RecursiveSection :section="section_child" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <RecursiveSection v-else-if="section.type === 'recursive'" :section="section" />
      <ol v-else class="mt-6 mb-15">
        <li
          v-for="(section_child, i_sc) in section.children"
          :key="section.title + i_section + i_sc"
          :class="{ 'mt-6': !!section_child.children && i_sc > 0 }"
        >
          <span v-if="section_child.title" class="item-title mr-1">{{ section_child.title }}:</span>
          <component :is="section_child.component || 'span'" v-html="section_child.text" v-bind="section_child.bind" />
          <ol v-if="section_child.children">
            <li
              v-for="(nested, i_nested) in section_child.children"
              :key="section.title + i_section + i_sc + i_nested"
              v-html="nested.text"
            />
          </ol>
        </li>
      </ol>
    </li>
  </ol>
</template>
<style>
  body {
    scroll-behavior: smooth;
  }
</style>
<style scoped lang="scss">
  ::v-deep .section {
    scroll-margin-top: 130px;
    @media #{$viewport-desktop-large-down} {
      scroll-margin-top: 190px;
    }
  }
  ol {
    color: rgba(#fff, 0.8);
    counter-reset: item;
    padding-left: unset;
    li {
      display: block;
      counter-increment: item;
      h2 {
        display: inline;
      }
      &:before,
      span.item-title {
        color: #fff;
        font-weight: 600;
      }
      &:before {
        content: counters(item, '.') '. ';
      }
      &:is(.section) {
        &:before {
          padding-left: 4px;
          font-size: 24px;
        }
      }

      li:before {
        content: counters(item, '.') ' ';
      }
      &.spoilers::v-deep {
        .v-expansion-panels {
          gap: 8px;
          .v-expansion-panel {
            background-color: rgba(#fff, 0.05);
            border-radius: 10px !important;
            color: #fff;
            button {
              font-size: 18px;
              padding: 25px 16px;
              @media #{$viewport-desktop-down} {
                font-size: 16px;
              }
            }
            .v-icon {
              color: #fff;
            }
            .v-expansion-panel-content {
              font-size: 16px;
              @media #{$viewport-desktop-down} {
                font-size: 15px;
              }
              color: rgba(#fff, 0.8);
              &__wrap {
                padding: 16px 16px 24px;
              }
              a {
                color: #f8bf1e;
                text-decoration: underline;
              }
            }
            &:before {
              display: none;
            }
            &--active {
              background-color: transparent;
              border: 1px solid #f8bf1e;
              margin: 0;
              & + .v-expansion-panel {
                margin: 0;
              }
            }
          }
        }
      }
    }
  }
</style>
